<template>
	<transition-group name="slot" tag="div" class="board">
		<v-touch v-for="slot in board" class="slot" :class="'slot-' + slot.position" :key="slot.id" @tap="play_card(slot)" @press="show_card(slot)">
			<transition name="card">
				<card v-if="slot.card" :card="slot.card"></card>
			</transition>
		
			<tuto-info v-if="user.first_times.tuto && slot.position === 1" :step="3"></tuto-info>
			<tuto-info v-if="user.first_times.tuto && slot.position === 5" :step="5"></tuto-info>
			<tuto-info v-if="user.first_times.tuto && slot.position === 15" :step="8"></tuto-info>
			<tuto-info v-if="user.first_times.tuto && slot.position === 8" :step="9" :error="step_9_error"></tuto-info>
		</v-touch>
	</transition-group>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from './Card'
import TutoInfo from './TutoInfo'

export default {
	name: 'Board',
	data () {
		return {
			step_9_error: false
		}
	},
	computed: Object.assign(mapGetters([ 'user', 'game', 'board' ]), {
		
	}),
	methods: {
		play_card: function(slot) {
			if (this.user.first_times.tuto) {
				if (this.game.tuto_step === 3) {
					if (slot.card.value == 2) {
						this.$store.dispatch('play_card', { slot: slot })
						var that = this
						setTimeout(function() {
							that.$store.dispatch('next_tuto');
						}, 500)
					}
				}
				else if (this.game.tuto_step === 5) {
					if (slot.card.value == 1 || slot.card.value == 2) {
						var that = this
						if (slot.card.value == 2) {
							setTimeout(function() {
								that.$store.dispatch('next_tuto');
							}, 500)
						}
						this.$store.dispatch('play_card', { slot: slot })
					}
				}
				else if (this.game.tuto_step === 8) {
					if (slot.card.value < 4) {
						var that = this
						if (slot.card.value == 3) setTimeout(function() { that.$store.dispatch('next_tuto'); }, 500)
						this.$store.dispatch('play_card', { slot: slot })
					}
				}
				else if (this.game.tuto_step === 9) {
					this.step_9_error = true
				}
			}
			else {
				this.$store.dispatch('play_card', { slot: slot })
				
			}
		},
		show_card: function(slot) {
			if (this.user.first_times.tuto) {
				if (this.game.tuto_step === 9) {
					this.$store.commit('SET_ACTIVE_CARD', { card: slot.card })
					this.$store.dispatch('next_tuto')
				}
			}
			else {
				this.$store.commit('SET_ACTIVE_CARD', { card: slot.card })
			}
		}
	},
	components: { Card, TutoInfo }
}
</script>

<style lang="stylus">
@import '../../assets/css/app'


.card-enter-active, .card-leave-active
	transition 0.25s easeOutQuart
	
.card-enter
	opacity 0
	transform translate3D(0, -(card_height / 2), 0)
	transform scale(0)
.card-leave-to
	opacity 0
	transform scale(2)



.board
	width ((card_width + 4px) * 4 + 4)
	height ((card_height + 4px) * 4 + 4)
	padding 2px
	display flex
	align-items center
	justify-content center
	flex-wrap wrap
	.slot
		margin 2px
		display inline-block
		width card_width
		height card_height
		border-radius 8px
		// box-shadow inset 0 3px 2px alpha(#000, 15%)
		// background alpha(#000, 10%)
		transition 0.25s easeOutQuart
		&:active
			transform translate3D(0, 2px, 0) scale(0.95)
		&.slot-enter-active, &.slot-leave-active
			for i in 1..16
				&:nth-child({i})
					transition-delay unit((i * 0.05), 's')
		&.slot-leave-active
			transition 0.75s easeOutQuart
		&.slot-enter, &.slot-leave-to
			opacity 0
			transform translate3D(0, -800px, 0)
		.position
			position absolute
			left 8px
			top 4px
			font-size 14px

</style>



// WEBPACK FOOTER //
// src/components/game/Board.vue